// API Configuration 
// Production API https://api.pawbii.com/a_qb-api/public/api/v1
// Test API https://apierp.orionclickz.com/public/api/v1/
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.pawbii.com/a_qb-api/public/api/v1',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/login',
      LOGOUT: '/logout',
      ME: '/me',
    },
    COMPANY: {
      BASE: '/company',
      LOGO: '/company/logo',
    },
    TAX_CODES: {
      GET_ALL: '/tax-codes',
      GET_BY_ID: '/tax-codes',
      CREATE: '/tax-codes',
      UPDATE: '/tax-codes',
      DELETE: '/tax-codes',
    },
    ROLES: '/roles',
    USERS: {
      GET_ALL: '/users',
      GET_BY_ID: '/users',
      CREATE: '/users',
      UPDATE: '/users', 
      DELETE: '/users'
    },
    CUSTOMERS: {
      GET_ALL: '/customers',
      CREATE: '/customers',
      UPDATE: '/customers',
      DELETE: '/customers',
      OPEN_INVOICES: '/customers',
      BULK_PAYMENT: '/customers',
      MERGE: '/customers'
    },
    SALES: { 
      GET_ALL: '/sales',
      CREATE: '/sales',
      CREATE_PAYMENT: '/sales'
    },
    INVOICES: {
      GET_ALL: '/invoices',
      GET_BY_ID: '/invoices',
      CREATE: '/invoices',
      UPDATE: '/invoices',
      DELETE: '/invoices',
      POST: '/invoices',
      VOID: '/invoices',
      COPY: '/invoices',
      PDF: '/invoices',
      SEND: '/invoices',
    },
    QUOTATIONS: {
      GET_ALL: '/quotations',
      GET_BY_ID: '/quotations',
      CREATE: '/quotations',
      UPDATE: '/quotations',
      DELETE: '/quotations',
      COPY: '/quotations',
      CONVERT_TO_INVOICE: '/quotations',
      PDF: '/quotations',
      SEND: '/quotations',
    },
    PURCHASE_ORDERS: {
      GET_ALL: '/purchase-orders',
      GET_BY_ID: '/purchase-orders',
      CREATE: '/purchase-orders',
      UPDATE: '/purchase-orders',
      DELETE: '/purchase-orders',
      PDF: '/purchase-orders',
      SEND: '/purchase-orders',
    },
    BILLS: {
      GET_ALL: '/bills',
      GET_BY_ID: '/bills',
      CREATE: '/bills',
      UPDATE: '/bills',
      DELETE: '/bills',
      RECEIVE: '/bills',
      VOID: '/bills',
      CORRECTION_PREVIEW: '/bills',
    },
    BILL_PAYMENTS: {
      GET_ALL: '/bill-payments',
      GET_BY_ID: '/bill-payments',
      CREATE: '/bill-payments',
      VOID: '/bill-payments',
    },
    CUSTOMER_PAYMENTS: {
      GET_ALL: '/customer-payments',
      GET_BY_ID: '/customer-payments',
      CREATE: '/customer-payments',
      APPLY_ALLOCATIONS: '/customer-payments',
      VOID: '/customer-payments',
      PDF: '/customer-payments',
      SEND: '/customer-payments',
    },
    PRODUCTS: {
      GET_ALL: '/products',
      GET_BY_ID: '/products',
      CREATE: '/products',
      UPDATE: '/products',
      DELETE: '/products'
    },
    ITEMS: {
      GET_ALL: '/items',
      GET_BY_ID: '/items',
      CREATE: '/items',
      UPDATE: '/items',
      DELETE: '/items',
      IMAGE: '/items',
    },
    ATTACHMENTS: {
      GET_ALL: '/attachments',
      GET_BY_ID: '/attachments',
      DOWNLOAD: '/attachments',
      DELETE: '/attachments',
      STAGING: '/attachments/staging',
      LINK: '/attachments',
    },
    CATEGORIES: {
      GET_ALL: '/categories',
      CREATE: '/categories',
      UPDATE: '/categories',
      DELETE: '/categories'
    },
    ITEM_CATEGORIES: {
      GET_ALL: '/item-categories',
      GET_BY_ID: '/item-categories',
      CREATE: '/item-categories',
      UPDATE: '/item-categories',
      DELETE: '/item-categories',
    },
    BRANDS: {
      GET_ALL: '/brands',
      CREATE: '/brands',
      UPDATE: '/brands',
      DELETE: '/brands'
    },
    UNITS: {
      GET_ALL: '/units',
      GET_BY_ID: '/units',
      CREATE: '/units',
      UPDATE: '/units',
      DELETE: '/units'
    },
    SUPPLIERS: {
      GET_ALL: '/vendors',
      OPEN_BILLS: '/vendors',
      BULK_PAYMENT: '/vendors'
    },
    ACCOUNTS: {
      GET_ALL: '/accounts',
      GET_BY_ID: '/accounts',
      CREATE: '/accounts',
      UPDATE: '/accounts',
      DELETE: '/accounts',
    },
    JOURNAL_ENTRIES: {
      GET_ALL: '/journal-entries',
      GET_BY_ID: '/journal-entries',
    },
    SALES_TRANSACTIONS: {
      GET_ALL: '/sales-transactions',
    },
    PURCHASE_TRANSACTIONS: {
      GET_ALL: '/purchase-transactions',
    },
    INVENTORY_TRANSACTIONS: {
      GET_ALL: '/inventory-transactions',
    },
    INVENTORY_ADJUSTMENTS: {
      GET_ALL: '/inventory-adjustments',
      GET_BY_ID: '/inventory-adjustments',
      CREATE: '/inventory-adjustments',
      VOID: '/inventory-adjustments',
    },
    INVENTORY_STARTING_VALUES: {
      GET_BY_ITEM: '/items',
      VOID_BY_ITEM: '/items',
      CORRECTION_PREVIEW_BY_ITEM: '/items',
      CORRECT_BY_ITEM: '/items',
      BULK: '/inventory-starting-values/bulk',
    },
    REPORTS: {
      TRIAL_BALANCE: '/reports/trial-balance',
      PROFIT_AND_LOSS: '/reports/profit-and-loss',
      PROFIT_AND_LOSS_DETAIL: '/reports/profit-and-loss-detail',
      BALANCE_SHEET: '/reports/balance-sheet',
      AR_AGING: '/reports/ar-aging',
      AP_AGING: '/reports/ap-aging',
      STOCK_VALUE: '/reports/inventory/stock-value',
      BANK_COLLATERAL: '/reports/inventory/bank-collateral',
      GROSS_PROFIT_SUMMARY: '/reports/gross-profit-summary',
      PAYMENT_METHOD_SUMMARY: '/reports/payment-method-summary',
      CUSTOMER_BALANCE_SUMMARY: '/reports/customer-balance-summary',
      CUSTOMER_BALANCE_DETAIL: '/reports/customer-balance-detail',
      VENDOR_BALANCE_SUMMARY: '/reports/vendor-balance-summary',
      VENDOR_BALANCE_DETAIL: '/reports/vendor-balance-detail',
      SALES_BY_CUSTOMER_SUMMARY: '/reports/sales-by-customer-summary',
      SALES_BY_CUSTOMER_DETAIL: '/reports/sales-by-customer-detail',
      SALES_BY_PRODUCT_SUMMARY: '/reports/sales-by-product-summary',
      SALES_BY_PRODUCT_DETAIL: '/reports/sales-by-product-detail',
      INCOME_BY_CUSTOMER_SUMMARY: '/reports/income-by-customer-summary',
      INCOME_BY_CUSTOMER_DETAIL: '/reports/income-by-customer-detail',
      INCOME_BY_CUSTOMER_INVOICE_DETAIL: '/reports/income-by-customer-invoice-detail',
    },
    PLATFORM: {
      COMPANIES: '/platform/companies',
    },
    SEARCH: '/search',
  }
};

// API utility functions
export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  const url = `${API_CONFIG.BASE_URL}${endpoint}`;

  const defaultHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };

  const token = localStorage.getItem('token');
  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const response = await fetch(url, config);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}; 